<div *ngIf="device" class="mc-device-details-card">
  <ul class="list-unstyled">
      <li *ngIf="!!device.deviceName">
          <span class="name"><span>{{'xs_name_label' | xsI18n}}</span></span>
          <span class="value">{{device.deviceName}}</span>
      </li>
      <li *ngIf="!!device.telno">
          <span class="name"><span>{{'label_Phone' | xsI18n}}</span></span>
          <span class="value">{{device.telno}}</span>
      </li>
      <li *ngIf="!!device.platform">
          <span class="name"><span>{{'label_Platform' | xsI18n}}</span></span>
          <span class="value">{{device.platform}}</span>
      </li>
      <li *ngIf="!!device.osVersion">
          <span class="name"><span>{{'label_OSVersion' | xsI18n}}</span></span>
          <span class="value">{{device.osVersion}}</span>
      </li>
      <li *ngIf="!!device.manufacturer">
          <span class="name"><span>{{'label_Manufacturer' | xsI18n}}</span></span>
          <span class="value">{{device.manufacturer}}</span>
      </li>
      <li *ngIf="!!device.model">
          <span class="name"><span>{{'label_Model' | xsI18n}}</span></span>
          <span class="value">{{device.model}}</span>
      </li>
      <li *ngIf="device.batteryStatus >= 0">
          <span class="name"><span>{{'label_Battery' | xsI18n}}</span></span>
          <span class="value">{{device.batteryStatus}}%</span>
      </li>
      <li *ngIf="!!device.serialNumber">
          <span class="name"><span>{{'label_Serial' | xsI18n}}</span></span>
          <span class="value">{{device.serialNumber}}</span>
      </li>
      <li *ngIf="!!device.mACAddress">
          <span class="name"><span>{{'label_MACAddress' | xsI18n}}</span></span>
          <span class="value">{{device.mACAddress}}</span>
      </li>
  </ul>
</div>
